var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-result",class:_vm.border},[_c('div',{staticClass:"inner"},[_c('i',{staticClass:"no-result-icon"}),_vm._v(" "),_c('p',{staticClass:"no-result-text",domProps:{"innerHTML":_vm._s(_vm.message)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }